"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.glassWare = void 0;

var glassWare = function glassWare(base, gradients) {
  return "\n        background-color: ".concat(base ? base : "rgba(66,135,245,0.5)", ";\n        background-image: ").concat(gradients ? "linear-gradient(45deg, ".concat(gradients, ");") : "linear-gradient(45deg, rgba(66,135,245,0.65), rgba(66,135,245,0.5), rgba(255,255,255,0.45), rgba(66,135,245,0.35), rgba(66,135,245,0.65));", ";\n    ");
};

exports.glassWare = glassWare;